import React from 'react';

export const MeasurementContext = React.createContext(false);
